/**
 * This schema represents a User as stored in Cognito
 * It includes meta data only.
 */
import { object, string, type InferType } from "yup"

export const CognitoUserDataSchema = object({
  created_at: string().required(),
  email: string(),
  email_verified: string(),
  id: string().required(),
  sub: string(),
  updated_at: string(),
  user_status: string(),
})

export type CognitoUserDataDto = InferType<typeof CognitoUserDataSchema>
